module.exports = __webpack_public_path__ + "img/myposition_cf_헤리 케인.9b37997d.png";